import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

interface UseCampaignPlansProps {
  currentPage?: number;
  pageSize?: number;
}

export function useCampaignPlans({ currentPage = 1, pageSize = 10 }: UseCampaignPlansProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const queryKey = `client-campaign-plans-${currentPage}-${pageSize}`;

  const {
    data = {},
    error,
    isLoading
  } = useQuery({
    queryKey,
    queryData: { currentPage, pageSize },
    queryFn: async () => {
      const plannerApiUrl = process.env.NEXT_PUBLIC_PLANNER_API_URL;
      if (!plannerApiUrl) {
        throw new Error('NEXT_PUBLIC_PLANNER_API_URL is not defined');
      }

      return getJson({
        url: `${plannerApiUrl}/planner/v1/campaign-drafts/search?page_number=${currentPage}&page_size=${pageSize}`,
        token
      }).then((response: Api.Planner.v1UserDraftsPage & ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return {
          drafts: response.drafts,
          pageNumber: response.page_number,
          pageSize: response.page_size,
          hasMore: response.has_more
        };
      });
    },
    enabled: !!token
  });

  return {
    isLoading,
    error,
    data
  };
}
